import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRewards1Nav = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "evenodd",
		d: "M19.093 6.225c-1.485.5-2.452 1.739-3.032 2.793a9.66 9.66 0 0 0-.061.113 9.66 9.66 0 0 0-.061-.113C15.193 7.662 13.806 6 11.5 6a3.5 3.5 0 0 0-3.162 5H6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1v9a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-9h1a1 1 0 0 0 1-1v-4a7.974 7.974 0 0 1-5.608-2.294A1.5 1.5 0 0 1 20.5 11h-3.154c.122-.32.277-.67.468-1.018.468-.85 1.065-1.533 1.832-1.826a7.944 7.944 0 0 1-.553-1.93Zm3.12.223A3.502 3.502 0 0 1 23.96 8.97a5.008 5.008 0 0 1-1.747-2.522ZM10.439 8.439A1.5 1.5 0 0 1 11.5 8c1.194 0 2.057.838 2.686 1.982.191.347.346.699.468 1.018H11.5a1.5 1.5 0 0 1-1.06-2.56ZM17 16v-3h8v3h-8Zm-2-3H7v3h8v-3Zm8 13h-6v-8h6v8Zm-8 0v-8H9v8h6Z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#D8161F",
		d: "M32 5a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
	})]
});
export default SvgRewards1Nav;
